<template>
  <div v-if="productTasksFeature.show" class="mb-6">
    <div v-if="productReleases.length > 0" class="card-item">
      <span class="is-flex is-align-items-center">
        <span class="icon-item is-flex is-align-items-center is-justify-content-center">
          <i class="fa-solid fa-truck-fast has-text-primary is-size-5" />
        </span>
        <span>
          <h4 class="has-text-grey has-text-weight-medium is-size-6 mt-0">{{ $t('teamReleasesMessage') }}</h4>
        </span>
      </span>
      <div class="box p-2 my-1" data-cy="doings-product">
        <div v-for="(message, index) in productReleases" :key="index" :class="['message-item', {'last-message': index === productReleases.length - 1}]">
          <div class="message-item-inner p-3 my-1">
            <header>
              <div>
                <div class="is-flex is-justify-content-space-between is-align-items-center">
                  <div class="is-flex is-align-items-center">
                    <div class="is-flex is-flex-direction-column">
                      <div>
                        <div class="is-flex is-align-items-center">
                          <p class="has-text-weight-medium is-size-6">{{ message.value }}</p>
                        </div>
                        <div class="is-flex is-align-items-center is-flex-wrap-wrap mt-2">
                          <a v-if="message.releaseLink" :href="message.releaseLink" target="_blank"><b-tag rounded icon="link" type="is-light mr-2">Ver</b-tag></a>
                          <b-tag rounded type="is-light mr-2">{{ message.productSection }}</b-tag>
                          <p class="is-size-7 has-text-grey-light">{{ message.country }}</p>
                          <p class="is-size-7 has-text-grey-light ml-2">{{ dateFormat(message.state.releaseDate) }}</p>
                          <div class="is-flex is-align-items-center">
                            <b-rate v-model="message.rating" icon-pack="fas" size="is-small" class="pt-2 ml-4" @input="handleRatingChange(message._id, $event)" />
                            <p class="is-size-7 has-text-grey-light ml-2">{{ message.votesNumber }} votos</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <b-button
                      class="toggleButton is-rounded ml-2"
                      size="is-small"
                      :aria-expanded="message.notificationCollapse"
                      aria-controls="notification"
                      @click="toggleNotificationCollapse(index, productReleases)">
                      <i :class="{ 'fa-angle-down': !message.notificationCollapse, 'fa-angle-up': message.notificationCollapse}" class="fas" aria-hidden="true" />
                    </b-button>
                  </div>
                </div>
              </div>
            </header>
            <b-collapse v-model="message.notificationCollapse" aria-id="notification" class="message-body is-size-7" animation="slide">
              <div class="content mt-3 p-4">
                <div class="is-flex">
                  <b-tag v-if="message.sprintNumber" rounded type="is-light" class="mr-2 team-icon">Sprint #{{ message.sprintNumber }}</b-tag>
                  <b-tag icon="people-group" class="team-icon mb-3" rounded type="is-light">{{ message.state.team }}</b-tag>
                </div>
                <p class="mb-0" v-html="message.description" />
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>
    <div v-if="productDoingsMessages.length > 0" class="mt-3 card-item">
      <span class="is-flex is-align-items-center">
        <span class="icon-item is-flex is-align-items-center is-justify-content-center">
          <i class="fa-solid fa-code has-text-primary is-size-5" />
        </span>
        <span>
          <h4 class="has-text-grey has-text-weight-medium is-size-6 mt-0">{{ $t('teamWorkingMessage') }}</h4>
        </span>
      </span>
      <div class="box p-2 my-1" data-cy="doings-product">
        <div v-for="(message, index) in productDoingsMessages" :key="index" :class="['message-item', {'last-message': index === productDoingsMessages.length - 1}]">
          <div class="message-item-inner p-3 my-1">
            <header>
              <div>
                <div class="is-flex is-justify-content-space-between is-align-items-center">
                  <div class="is-flex is-align-items-center">
                    <div class="is-flex is-flex-direction-column">
                      <div>
                        <div class="is-flex is-align-items-center">
                          <p class="has-text-weight-medium is-size-6">{{ message.value }}</p>
                        </div>
                        <div class="is-flex is-align-items-center mt-2">
                          <a v-if="message.releaseLink" :href="message.releaseLink" target="_blank"><b-tag rounded icon="link" type="is-light mr-2">Ver</b-tag></a>
                          <b-tag rounded type="is-light mr-2">{{ message.productSection }}</b-tag>
                          <p class="is-size-7 has-text-grey-light">{{ message.country }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <b-button
                      class="toggleButton is-rounded ml-2"
                      size="is-small"
                      :aria-expanded="message.notificationCollapse"
                      aria-controls="notification"
                      @click="toggleNotificationCollapse(index, productDoingsMessages)">
                      <i :class="{ 'fa-angle-down': !message.notificationCollapse, 'fa-angle-up': message.notificationCollapse}" class="fas" aria-hidden="true" />
                    </b-button>
                  </div>
                </div>
              </div>
            </header>
            <b-collapse v-model="message.notificationCollapse" aria-id="notification" class="message-body is-size-7" animation="slide">
              <div class="content mt-3 p-4">
                <div class="is-flex">
                  <b-tag v-if="message.sprintNumber" rounded type="is-light" class="mr-2 team-icon">Sprint #{{ message.sprintNumber }}</b-tag>
                  <b-tag icon="people-group" class="team-icon mb-3" rounded type="is-light">{{ message.state.team }}</b-tag>
                </div>
                <p class="mb-0" v-html="message.description" />
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FeatureToggleProductTasks } from '@/application/services/feature-toggle-product-tasks';
import { getFeatureToggleByName } from '@/application/services/api-clients/features-toggles';
import { getAllProductTasks, updateRating } from '@/application/services/api-clients/product-tasks';
import currentUser from '@/ui/mixins/current-user';
import locale from '@/ui/mixins/locale';
import { dateToFormatedString } from '@/infrastructure/date';

export default {
  name: 'ProductDoings',
  mixins: [currentUser, locale],
  data() {
    return {
      productTasksFeature: {
        show: false
      },
      dataProductTasksMessages: [],
      currentUserRol: this.currentUser().user.rol,
      currentUserId: this.currentUser().user._id,
      rating: 0, // Inicializa con un valor por defecto
      featureToggleId: '' // Asegúrate de que este valor sea el correcto
    };
  },
  computed: {
    productReleases() {
      return this.dataProductTasksMessages.filter(message => message.state.releaseDate !== null);
    },
    productDoingsMessages() {
      return this.dataProductTasksMessages.filter(message => message.state.releaseDate === null);
    }
  },
  async mounted() {
    await this.loadProductTasksFeature();
    await this.loadProductTasksMessages();
  },
  methods: {
    dateFormat: date => dateToFormatedString(date, 'DD/MM/YYYY'),
    async loadProductTasksFeature() {
      try {
        if (this.currentUserRol !== 'CLIENT') {
          const productTasksFeature = new FeatureToggleProductTasks(getFeatureToggleByName);
          const dataProductTasksFeature = await productTasksFeature.getProductTasksFeature();
          this.productTasksFeature.show = dataProductTasksFeature.isActive;
        }
      } catch (e) {
        this.$log.error(`error getting feature toggle product-doings. Cause: ${e.message}`);
      }
    },
    async loadProductTasksMessages() {
      this.dataProductTasksMessages = await getAllProductTasks();
    },
    toggleNotificationCollapse(index, state) {
      state[index].notificationCollapse = !state[index].notificationCollapse;
    },
    async handleRatingChange(productTaskId, newRating) {
      this.rating = newRating;
      this.productTaskId = productTaskId;
      try {
        await updateRating(
          this.productTaskId,
          this.rating
        );
      } catch (e) {
        this.$log.error(`error updating rating. Cause: ${e.message}`);
      }
    }
  }
};
</script>

<style lang="css" scoped>

.message-item {
  border-bottom: 0.1rem solid #f0f0f0;
}
.message-item-inner:hover {
  background-color: #f8f8f8ad;
  border-radius: 10px;
}
.last-message {
  border: none;
}
.message-body {
  padding: 0;
  border: none;
}
.message-body .content {
  padding: 0;
  border: 0.2px solid #f0f0f0;
  border-radius: 0.5rem;
  background-color: #ffffffad;
}

.message-header button {
  -webkit-transition: all 300ms ease-in-out;
  -moz-transition: all 300ms ease-in-out;
  -ms-transition: all 300ms ease-in-out;
  -o-transition: all 300ms ease-in-out;
  transition: all 300ms ease-in-out;
}

.toggleButton {
  -webkit-appearance: none;
  color: var(--primary);
  border: none;
  cursor: pointer;
  pointer-events: auto;
  display: inline-block;
  -webkit-box-flex: 0;
}

.team-icon {
  zoom: 90%;
}
</style>
<style>

.message-body code {
  color: var(--color-nickel);
  background-color: #f5f5f5;
  border-radius: 20rem;
}

</style>

<i18n>
  {
    "cl": {
      "teamWorkingMessage":"Estamos trabajando:",
      "teamReleasesMessage":"Nuevos incrementos:"
    },
    "br": {
      "teamWorkingMessage":"Estamos trabalhando:",
      "teamReleasesMessage":"Novos desenvolvimentos:"
    },
    "pe": {
      "teamWorkingMessage":"Estamos trabajando:",
      "teamReleasesMessage":"Nuevos incrementos:"
    }
  }
</i18n>
